module.exports = __webpack_public_path__ + "img/thumbfield3.d94dd9c8.png";